<ng-container *ngIf="cart$ | async as cart">
  <div class="cx-cart-coupon-title">
    {{ 'voucher.coupon' | cxTranslate }}
  </div>

  <div class="form-group">
    <form novalidate (submit)="applyVoucher()" [formGroup]="form">
      <div class="d-flex">
        <div class="cx-apply-voucher w-100 mr-2" [ngClass]="activeLanguage$ | async">
          <mat-form-field
            appearance="outline"
            class="w-100"
            [ngClass]="couponInputDataHasValue && 'mat-form-field-should-float'"
            [hideRequiredMarker]="true"
          >
            <mat-label [hidden]="!couponInputDataHasValue">{{
              'voucher.couponInputOutlineLabel' | cxTranslate
            }}</mat-label>

            <input
              matInput
              #couponInput
              type="text"
              [placeholder]="'voucher.placeholder' | cxTranslate"
              id="applyVoucher"
              formControlName="couponCode"
              aria-label="applyVoucher"
              (focus)="open(); click()"
              (input)="change(couponInput.value)"
              (blur)="inActive(couponInput.value)"
              (focusout)="addPlaceholder()"
              (keydown.escape)="close($event)"
              autocomplete="off"
            />
          </mat-form-field>

          <div [class.couponbox-is-active]="couponBoxIsActive">
            <div
              *ngIf="filteredCoupons && filteredCoupons.length > 0"
              class="cx-customer-coupons"
              (click)="close($event)"
            >
              <div class="coupons" (mousedown)="disableClose()">
                <a *ngFor="let coupon of filteredCoupons" (click)="applyCustomerCoupon(coupon.couponId)">
                  <div class="coupon-id">{{ coupon.couponId }}</div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <button
          class="btn btn-block btn-action apply-coupon-button secondary-btn"
          [ngClass]="activeLanguage$ | async"
          type="submit"
          [disabled]="(submitDisabled$ | async) || showSrp"
          [class.disabled]="(submitDisabled$ | async) || showSrp"
          [ngClass]="activeLanguage$ | async"
        >
          {{ 'voucher.apply' | cxTranslate }}
        </button>
      </div>
    </form>
  </div>

  <cx-applied-coupons [vouchers]="cart.appliedVouchers" [cartIsLoading]="cartIsLoading$ | async" [isReadOnly]="false">
  </cx-applied-coupons>
</ng-container>
